export default "__VITE_ASSET__DINjaEij__"